export const DESKTOP_PREVIEW_WIDTH = 320;
export const DESKTOP_PREVIEW_WIDTH_COMPACT = 272;

// Приблизительная высота превью - только для эвристики выбора стороны балуна.
// Реальная высота карточки динамическая; точное вертикальное смещение задаётся в CSS (translateY %).
// Compact ниже на срез галереи (см. .carousel--compact в styles.css: 160 -> 136).
const COMPACT_GALLERY_CROP = 24;
export const DESKTOP_PREVIEW_HEIGHT = 302;
export const DESKTOP_PREVIEW_HEIGHT_COMPACT = DESKTOP_PREVIEW_HEIGHT - COMPACT_GALLERY_CROP;

// Ниже этой ширины окна desktop-превью становится компактным (272). Дробь исключает ровно 1366.
export const DESKTOP_PREVIEW_COMPACT_MEDIA_QUERY = '(max-width: 1365.98px)';
